import React, { Component } from "react";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import { Div, Text, Image } from "atomize";
import ImageLink from "../common/ImageLink";
import { IsValidUrl } from "../../utilities/helpers";

export default class CampaignShipping extends Component {
  render() {
    const { content } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer>
          <Div
            className="solutions"
            d="flex"
            m={{ t: "5.125rem" }}
            flexDir={{ xs: "column-reverse", md: "row" }}
          >
            <Div d="flex" flexDir="column" justify="center" flexGrow="1">
              <Div p={{ r: { xs: "0", md: ".5rem", lg: "3rem" } }}>
                <Text m={{ b: ".7rem" }} textSize="title2" tag="h2" textWeight="700">
                  {content.heading}
                </Text>
                <Text
                  className="sub-text"
                  textSize={{ xs: "15px", md: "paragraph" }}
                  textColor="gray450"
                >
                  {content.text1}
                </Text>
                <Text
                  className="sub-text"
                  m={{ y: "1.8rem" }}
                  textSize={{ xs: "15px", md: "paragraph" }}
                  textColor="gray450"
                >
                  {content.text2}
                </Text>
                <Text
                  textSize="paragraph"
                  className="sub-text"
                  textSize={{ xs: "15px", md: "paragraph" }}
                  textColor="gray450"
                >
                  {content.text3}
                </Text>
              </Div>
            </Div>
            <Div flexGrow="1" m={{md: "auto"}}>
              <ImageLink link={content.imgLink}><Div
                bgImg={content.img}
                bgSize="cover"
                p={{ b: "92.8%" }}
                m={{ l: { xs: "0", md: "1rem" }, b: { xs: "1.5rem", md: "0" } }}
              ></Div></ImageLink>
              {/* <Image src="" h="27.2rem" w="100%" /> */}
            </Div>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}
